export default "__VITE_ASSET__BcYZ$Kbg__"